import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const SkeletonTextBase = styled.div.withConfig({
  displayName: "SkeletonText__SkeletonTextBase"
})(["background-color:", ";border-radius:999px;display:inline-block;height:0.8em;width:6em;"], ({
  theme
}) => theme.color['border-core-subtle']);

/**
 * A simple skeleton ui for text which is currently loading; shows a gray bar.
 * It's approximately the height of average text in the current font size (0.8em),
 * so it looks sort of like text when you squint.
 */
export const SkeletonText = _ref => {
  let attributes = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  // @bend-expect trellis-tokenized
  return /*#__PURE__*/_jsx(SkeletonTextBase, Object.assign({}, attributes, {
    role: "status",
    "aria-busy": "true",
    "data-loading": "true"
  }));
};